import {useState} from 'react'
import {Button, Heading, Popover} from '@primer/react'
import {useIsSingleFileMode} from '../../stores/selectors'

import styles from './SingleFileModeOnboardingPopover.module.css'
import {clsx} from 'clsx'
import {useDismissNotice, useIsNoticeDismissed} from '../../hooks/use-user-notices'
import {Notices, type FilesPageNotices, type UserNotice} from '../../page-data/payloads/files'

const NOTICE_NAME = Notices.SingleFileMode

type SingleFileModeOnboardingPopoverProps = {
  /**
   * Optional user notices to use instead of route payload.
   * Use this when consuming data from data router (useRouteQuery).
   */
  userNotices?: Array<UserNotice<FilesPageNotices>>
}

export function SingleFileModeOnboardingPopover({userNotices}: SingleFileModeOnboardingPopoverProps) {
  const isNoticeDismissed = useIsNoticeDismissed(NOTICE_NAME, userNotices)
  const isSingleFileMode = useIsSingleFileMode()
  const [isOpen, setIsOpen] = useState(true)
  const {dismissNotice} = useDismissNotice(NOTICE_NAME, userNotices)

  const handleClick = () => {
    dismissNotice()
    setIsOpen(false)
  }
  if (!isSingleFileMode) return null
  if (isNoticeDismissed) return null
  return (
    <Popover className={styles.PopoverContainer} open={isOpen}>
      <Popover.Content className={clsx('d-flex flex-column gap-2', styles.PopoverContent)}>
        <Heading as="h3" variant="small" className={styles.Heading}>
          You&apos;re in single-file mode
        </Heading>
        <p>Due to the large number of changes in this pull request, only one file is being shown at a time.</p>
        <p>
          Use the <strong>Previous</strong> and <strong>Next</strong> buttons to move between files.
        </p>
        <div className="d-flex flex-items-center">
          <Button onClick={handleClick}>OK, got it</Button>
        </div>
      </Popover.Content>
    </Popover>
  )
}

try{ SingleFileModeOnboardingPopover.displayName ||= 'SingleFileModeOnboardingPopover' } catch {}